import { render, staticRenderFns } from "./Engagement.vue?vue&type=template&id=3ba4889e"
import script from "./Engagement.vue?vue&type=script&lang=js"
export * from "./Engagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports